import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../Slot';
import { Layout } from '../styles';

const VerticalLargeAndSmall = ({ slot }) => {
	const topSlot = slot[0];
	const bottomSlot = slot[1];

	return (
		<Layout>
			<Slot
				top={topSlot.type === 'image' ? 0 : 5}
				left={topSlot.type === 'image' ? 0 : 5}
				width={topSlot.type === 'image' ? 100 : 90}
				height={65}
				component={topSlot.type}
				data={topSlot.data}
				layout={topSlot.layout}
			/>
			<Slot
				top={70}
				left={5}
				width={90}
				height={25}
				component={bottomSlot.type}
				data={bottomSlot.data}
				layout={bottomSlot.layout}
			/>
		</Layout>
	)
}

VerticalLargeAndSmall.defaultProps = {
	slot: []
}

VerticalLargeAndSmall.propTypes = {
	slot: PropTypes.array,
}

export default VerticalLargeAndSmall
